import moment from "moment";
import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { Edit, SimpleForm, TextInput, SelectInput, NumberInput } from 'react-admin';
import { useForm } from 'react-final-form';

import { _clientUserStorage } from "../../utils/storage";

const useStyles = makeStyles(theme => ({
    form: {
        width: "100%",
        "& > div > div > div:first-child": {
            width: "100%",
        }
    },
}));

const CreateComponent = (props) => {
    const classes = useStyles();
    return (
        <Edit {...props} title="Edit" >
            <SimpleForm className={classes.form} redirect={"list"} >
                <Grid container spacing={3}>
                    <Grid item sm={12}>
                        <TextInput label="name" source="name" fullWidth />
                    </Grid>
                    <Grid item sm={12}>
                        <TextInput label="Description" source="description" multiline rows={4} fullWidth />
                    </Grid>
                    <Grid item sm={4}>
                        <SelectInput
                            label="Status"
                            source="status"
                            choices={[{
                                id: "active",
                                name: "Active"
                            }, {
                                id: "inactive",
                                name: "Inactive"
                            }]}
                            fullWidth
                            defaultValue={1}
                        />
                    </Grid>

                    <Grid item sm={4}>
                        <NumberInput
                            label="Latitude"
                            source="latitude"
                            initialValue={0}
                            fullWidth
                        />
                    </Grid>
                    <Grid item sm={4}>
                        <NumberInput
                            label="Longitude"
                            source="longitude"
                            initialValue={0}
                            fullWidth
                        />
                    </Grid>

                    <Grid item sm={4}>
                        <NumberInput
                            label="Radius (mét)"
                            source="radius"
                            initialValue={0}
                            fullWidth
                        />
                    </Grid>
                    <Grid item sm={4}>
                        <NumberInput
                            label="Point Reward"
                            source="point_reward"
                            initialValue={0}
                            fullWidth
                        />
                    </Grid>

                    <Grid item sm={4}>
                        <NumberInput
                            label="Cooldown hour(s)"
                            source="cooldown_hours"
                            initialValue={0}
                            fullWidth
                        />
                    </Grid>


                </Grid>
            </SimpleForm >
        </Edit >
    )
};

export default CreateComponent;
